import { gaeApp } from '../helpers/Analytics';
import { endJourney, JOURNEY } from '../../telemetry/tracing';

/** Shared analytics / journey side-effects for credentials collect. */
export function reportCredentialsCancelled() {
  gaeApp('USER_CREDENTIALS.FORM_CANCEL');
  // SUBMIT cascades → prepare + credentials
  endJourney(JOURNEY.SUBMIT, 'reject', 'credentials_cancelled');
}

export function reportCredentialsDone() {
  gaeApp('USER_CREDENTIALS.FORM_DONE');
  endJourney(JOURNEY.CREDENTIALS, 'ok', {
    'credentials.result': 'collected'
  });
}
